module.exports = __webpack_public_path__ + "static/media/MYSTIC 5..483ca426.jpg";